module.exports = __webpack_public_path__ + "img/uzbekistan.0331ab7c.svg";